/* eslint-disable @typescript-eslint/no-use-before-define */
import { all, call, fork, put, takeEvery, select } from "redux-saga/effects";
import { NotificationManager } from "@kernel-helpers/react-notifications";

import {
  getDashboardData,
  getDashboardFilters,
} from "@kernel-helpers/DatabaseHelpers";

import {
  GET_DASHBOARD_DATA_REQUEST,
  GET_DASHBOARD_DATA_ERROR,
  GET_DASHBOARD_FILTERS_REQUEST,
  GET_DASHBOARD_FILTERS_ERROR,
  SET_DASHBOARD_FILTER_FIELD,
  GET_DASHBOARD_DATA_SUCCESS,
  CLEAR_DASHBOARD_FILTERS,
} from "@kernel-store/actions";

import { getVideoListRequest } from "@kernel-store/videos/actions";
import { ReduxState } from "@kernel-store/reducers";
import {
  getDashboardDataSuccess,
  getDashboardDataError,
  getDashboardFiltersSuccess,
  getDashboardFiltersError,
  setDashboardAggregationParams,
} from "./actions";

import { EMPTY_FILTER } from "./reducer";

export function* watchGetDashboardDataRequest() {
  yield takeEvery(GET_DASHBOARD_DATA_REQUEST, getDashboardDataRequestSaga);
}

export function* watchGetDashboardDataError() {
  yield takeEvery(GET_DASHBOARD_DATA_ERROR, getDashboardDataErrorSaga);
}

export function* watchGetDashboardFiltersRequest() {
  yield takeEvery(
    GET_DASHBOARD_FILTERS_REQUEST,
    getDashboardFiltersRequestSaga,
  );
}

export function* watchgetDashboardFiltersError() {
  yield takeEvery(GET_DASHBOARD_FILTERS_ERROR, getDashboardFiltersErrorSaga);
}

export function* watchSetDashboardFilterField() {
  yield takeEvery(SET_DASHBOARD_FILTER_FIELD, getDashboardDataRequestSaga);
}

export function* watchClearDashboardFilters() {
  yield takeEvery(CLEAR_DASHBOARD_FILTERS, getDashboardDataRequestSaga);
}

export function* watchGetDashboardDataSuccess() {
  yield takeEvery(GET_DASHBOARD_DATA_SUCCESS, getDashboardDataSuccessSaga);
}
function* getDashboardDataErrorSaga() {
  yield 0;
  NotificationManager.warning(
    "Error getting data. Please take a screenshot and contact support.",
    "Error Getting Data",
    5000,
    null,
    null,
    "",
  );
}

function* getDashboardDataSuccessSaga() {
  const state: ReduxState = yield select();
  console.log("[GET_VIDEO_LIST] dashboardSuccess");
  yield put(
    getVideoListRequest(
      state.authUser.user.uid,
      state.authUser.user.companyId,
      state.authUser.user.groupId,
    ),
  );
}

function* getDashboardFiltersErrorSaga() {
  yield 0;
  NotificationManager.warning(
    "Error getting filters. Please take a screenshot and contact support.",
    "Error Getting Filters",
    5000,
    null,
    null,
    "",
  );
}

function* getDashboardDataRequestSaga({ payload }: any) {
  const { assessmentsByFieldParam, dateGranularityParam, aggType } = payload;
  const state: ReduxState = yield select();
  let fieldParam = assessmentsByFieldParam;
  let granularityParam = dateGranularityParam;
  let dashboardAggType = aggType;
  let { filterObject } = state.dashboard;
  if (filterObject === undefined) {
    filterObject = (yield call(getDashboardFilters)) as unknown as any;
  }
  const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  // jank deep copy
  const filterObjectModified = JSON.parse(JSON.stringify(EMPTY_FILTER));
  if (fieldParam === null || fieldParam === undefined || fieldParam === "") {
    fieldParam = state.dashboard.dashboardFieldParam;
  }
  if (
    granularityParam === null ||
    granularityParam === undefined ||
    granularityParam === ""
  ) {
    granularityParam = state.dashboard.dashboardGranularity;
  }
  if (
    dashboardAggType === null ||
    dashboardAggType === undefined ||
    dashboardAggType === ""
  ) {
    dashboardAggType = state.dashboard.dashboardAggType;
  }
  yield put(
    setDashboardAggregationParams(
      fieldParam,
      granularityParam,
      dashboardAggType,
    ),
  );
  filterObject.metadata_array.forEach((metadataObj: any) => {
    filterObjectModified.metadata_array.push({
      field_id: metadataObj.field_id,
      option_ids: metadataObj.values.map((x: any) => x.value),
    });
  });

  filterObjectModified.assessment_types = filterObject.assessment_types.map(
    (x: any) => x.value,
  );
  filterObjectModified.assessors = filterObject.assessors.map(
    (x: any) => x.value,
  );
  filterObjectModified.groups = filterObject.groups.map((x: any) => x.value);
  filterObjectModified.subject1_risk_levels =
    filterObject.subject1_risk_levels.map((x: any) => x.value);

  if (filterObject.start_date !== null && filterObject.start_date.isValid())
    filterObjectModified.start_date =
      filterObject.start_date.format("MM/DD/YYYY");
  if (filterObject.end_date !== null && filterObject.end_date.isValid())
    filterObjectModified.end_date = filterObject.end_date.format("MM/DD/YYYY");

  if (fieldParam === undefined) {
    fieldParam = "";
  }
  if (granularityParam === undefined) {
    granularityParam = "";
  }
  let dashboardData = null;
  try {
    dashboardData = (yield call(
      getDashboardData,
      filterObjectModified,
      fieldParam,
      granularityParam,
      clientTimezone,
      dashboardAggType,
    )) as unknown as any; // TODO(znoland): filters go here
  } catch (e) {
    yield put(getDashboardDataError());
    return;
  }
  yield put(getDashboardDataSuccess(dashboardData));
}

function* getDashboardFiltersRequestSaga() {
  // const {  } = payload;
  let dashboardFilters = null;
  try {
    dashboardFilters = (yield call(getDashboardFilters)) as unknown as any; // TODO(znoland): filters go here
  } catch (e) {
    yield put(getDashboardFiltersError());
    return;
  }

  yield put(getDashboardFiltersSuccess(dashboardFilters));
}

export default function* rootSaga() {
  yield all([
    fork(watchGetDashboardDataRequest),
    fork(watchGetDashboardDataError),
    fork(watchGetDashboardFiltersRequest),
    fork(watchgetDashboardFiltersError),
    fork(watchSetDashboardFilterField),
    fork(watchGetDashboardDataSuccess),
    fork(watchClearDashboardFilters),
  ]);
}
